export const UPDATE_COMPANY_PROFILE =
  'onboarding/companyProfile/UPDATE_COMPANY_PROFILE'
